import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8 9L5 12L8 15L8.707 14.293L6.914 12.5L19 12.5V11.5L6.914 11.5L8.707 9.707L8 9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLong02Left"
);
